export const matrix = {
  configFor: 'Configuration template for',
  title: 'Hierarchical view of products and assignments',
  possibilities: 'Possibilities',
  noData: 'No data to display',
  closeAll: 'Close all',
  openAll: 'Open all',
  all: 'All',
  active: 'With assigned configuration templates',
  inactive: 'Without assigned configuration templates',
} as const
